import Swiper from "swiper11";
import { SwiperOptions } from "swiper11/types";
// export function lazyLoad() {
//   const lazyImages = $("body").find("img[yige-src],*[yige-background]");
//   lazyImages.each((_i, el) => {
//     const SRC = $(el).attr("yige-src");
//     const BACKGROUND = $(el).attr("yige-background");
//     if (SRC) {
//       $(el).attr("src", SRC);
//     }
//     if (BACKGROUND) {
//       $(el).css("background-image", `url(${BACKGROUND})`);
//     }
//   });
// }

export function lazyLoad(offset: string = "50%") {
  const imgList = $("img[yige-src]");
  const backgroundList = $("*[yige-background]");
  if ("IntersectionObserver" in window) {
    const loading: IntersectionObserverCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = $(entry.target);
          const SRC = (el.attr("yige-src") as string) || "";
          const BACKGROUND = $(el).attr("yige-background");
          if (SRC) {
            $(el).attr("src", SRC);
          }
          if (BACKGROUND) {
            $(el).css("background-image", `url(${BACKGROUND})`);
          }
          observer.unobserve(entry.target);
        }
      });
    };
    const observer = new IntersectionObserver(loading, {
      root: null,
      rootMargin: `0px 0px ${offset} 0px`,
      threshold: 0,
    });
    imgList.each((i, el) => {
      observer.observe(el);
    });
    backgroundList.each((i, el) => {
      observer.observe(el);
    });
  } else {
    imgList.each((i, img) => {
      const SRC = $(img).attr("yige-src");
      if (SRC) {
        $(img).attr("src", SRC);
      }
    });
    backgroundList.each((i, background) => {
      const BACKGROUND = $(background).attr("yige-background");
      if (BACKGROUND) {
        $(background).css("background-image", `url(${BACKGROUND})`);
      }
    });
  }
}

/**
 * 调整图片及其容器大小的函数。
 *
 * 该函数根据图片的自然宽高，将图片及其父容器（如果需要）调整为特定尺寸，同时支持回调函数执行额外操作。
 *
 * @function resetImgSize
 * @param {Object} options - 配置对象。
 * @param {JQuery<HTMLElement>} options.nodeList - 包含图片元素的jQuery对象列表。
 * @param {boolean} [options.setImg=true] - 可选字段，是否设置图片的宽高，默认为`true`。
 * @param {boolean} [options.setBox=false] - 可选字段，是否设置图片父容器（`.img-box`）的宽高，默认为`false`。
 * @param {Function} [options.cb] - 可选字段，回调函数，在每张图片调整完成后执行。
 *
 * @returns {Array<Object>} - 返回一个数组，包含每个处理过的图片元素及其对应的宽高信息。
 * @returns {HTMLElement} item - 被处理的图片元素。
 * @returns {string} w - 处理后的图片宽度（以rem为单位）。
 * @returns {string} h - 处理后的图片高度（以rem为单位）。
 */
export function resetImgSize({ nodeList, setImg = true, setBox = false, cb }: ResetImgSizeFn) {
  const temp: any[] = [];
  nodeList.each((_i, img) => {
    if (!$(img).is("img")) return;
    function resizeImage(image: HTMLImageElement) {
      const originalH = image.naturalHeight / 10 + "rem";
      const originalW = image.naturalWidth / 10 + "rem";
      if (setBox) {
        $(image).parents(".img-box").eq(0).css({
          height: originalH,
          width: originalW,
        });
      }
      if (setImg) {
        $(image).css({
          height: originalH,
          width: originalW,
        });
      }
      temp.push({
        item: img,
        w: originalW,
        h: originalH,
      });
      if (cb && typeof cb === "function") cb();
    }
    if ((img as HTMLImageElement).complete) {
      // 如果图片已加载
      resizeImage(img as HTMLImageElement);
    } else {
      $(img).on("load", function () {
        resizeImage(this as HTMLImageElement);
      });
    }
  });
  return temp;
}

/**
 * 处理表单提交并发送询盘请求的函数。
 *
 * 该函数绑定点击事件到触发器元素上，验证表单数据并通过Ajax发送请求。在成功提交后，可执行自定义回调函数或跳转到指定页面。
 *
 * @function handleSendInquiry
 * @param {string} formId - 要提交的表单的ID选择器。
 * @param {string} trigger - 用于触发表单提交的元素选择器。
 * @param {Object} [opts.inquiryMsg] - 可选的字段提示信息对象，当字段为空时显示自定义提示信息。
 * @param {Function} [opts.fn] - 可选的自定义验证函数，在表单提交前执行，可用于处理额外的验证逻辑。
 * @param {Function} [opts.onSuccess] - 可选的成功回调函数，在请求成功后执行。
 *
 * @returns {void}
 */
// export function handleSendInquiry({ formId, trigger, opts }: SendInquiryOpts) {
//   const formEl = $(formId)[0] as HTMLFormElement;
//   $(trigger).on("click", () => {
//     const triggerElement = $(formEl).data("triggerElement");
//     const formData = new FormData(formEl);
//     const readyToSend = beforeSubmit(formData);
//     if (readyToSend) sendAjax(formData, triggerElement);
//   });
//   const beforeSubmit = (data: FormData) => {
//     let FLAG = true;
//     data.forEach((_val, key, data) => {
//       const is_required = $(formEl[key]).attr("required") == "required";
//       if (is_required && data.get(key) === "") {
//         FLAG = false;
//         let msg: string | undefined = undefined;
//         if (opts && opts.inquiryMsg && opts.inquiryMsg[key]) {
//           msg = opts.inquiryMsg[key];
//         }
//         throw rejectMessage(key, msg);
//       }
//     });
//     /*! custom Setting Start */
//     if (opts && opts.fn && typeof opts.fn === "function") {
//       opts.fn(data);
//     }
//     return FLAG;
//   };
//   const rejectMessage = (key: string, msg?: string) => {
//     formEl[key].focus();
//     alert(msg ?? `${key} can not be empty!`);
//   };
//   const sendAjax = (data: FormData, originalTrigger: HTMLElement) => {
//     $.ajax({
//       processData: false,
//       contentType: false,
//       type: "POST",
//       url: "/inquiry",
//       data: data,
//       success: function (jsonResult) {
//         if (jsonResult.code == 200) {
//           ($(formEl)[0] as HTMLFormElement).reset();
//           if (opts && opts.onSuccess && typeof opts.onSuccess === "function") {
//             opts.onSuccess(jsonResult, originalTrigger);
//           } else {
//             alert(jsonResult.msg);
//             location.href = "/page/thanks.html";
//           }
//         } else {
//           alert(jsonResult.msg);
//         }
//         $(":input[name = '__token__']").val(jsonResult.data.token);
//       },
//       error: function (data) {
//         alert(data.responseText);
//       },
//     });
//   };
// }

/*! Update in 2024-9-16 chw */
export function handleSendInquiry({ formId, trigger, opts }: SendInquiryOpts) {
  const formEl = $(formId)[0] as HTMLFormElement;
  $(trigger).on("click", () => {
    const triggerElement = $(formEl).data("triggerElement");
    const formData = new FormData(formEl);
    const readyToSend = beforeSubmit(formData);
    if (readyToSend) {
      if (opts && opts.onBeforeSend && typeof opts.onBeforeSend === "function") {
        opts.onBeforeSend(formData);
      }
      sendAjax(formData, triggerElement);
    }
  });
  const beforeSubmit = (data: FormData) => {
    let FLAG = true;
    const disableFields: any = {};
    const formElements = formEl.elements;
    for (let i = 0; i < formElements.length; i++) {
      const element = formElements[i] as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
      const key = element.name;
      const type = element.type;
      if (type === "file" && (data.get(key)! as File).name === "") {
        data.delete(key);
      }
      if (element.disabled && element.value) {
        data.set(key, element.value);
      }
      const is_required = element.required;
      if (is_required && element.value === "") {
        FLAG = false;
        let msg: string | undefined = undefined;
        if (opts && opts.inquiryMsg && opts.inquiryMsg[key]) {
          msg = opts.inquiryMsg[key];
        }
        rejectMessage(key, msg);
        break;
      }
    }
    /*! custom Setting Start */
    if (opts && opts.fn && typeof opts.fn === "function") {
      opts.fn({ data, disableFields, rejectMessage });
    }
    return FLAG;
  };
  const rejectMessage = (key: string, msg?: string) => {
    formEl[key].focus();
    alert(msg ?? `${key} can not be empty!`);
  };
  const sendAjax = (data: FormData, originalTrigger: HTMLElement) => {
    $.ajax({
      processData: false,
      contentType: false,
      type: "POST",
      url: "/inquiry",
      data: data,
      success: function (jsonResult) {
        if (jsonResult.code == 200) {
          ($(formEl)[0] as HTMLFormElement).reset();
          if (opts && opts.onSuccess && typeof opts.onSuccess === "function") {
            opts.onSuccess(jsonResult, originalTrigger);
          } else {
            location.href = "/page/thanks.html";
          }
        } else {
          if (opts && opts.onReject && typeof opts.onReject === "function") {
            opts.onReject(data, originalTrigger);
            alert(jsonResult.msg);
          }
        }
        $(":input[name = '__token__']").val(jsonResult.data.token);
      },
      error: function (data) {
        // if (opts && opts.onReject && typeof opts.onReject === "function") {
        //   opts.onReject(data, originalTrigger);
        //   alert(jsonResult.msg);
        // }
      },
    });
  };
}

export function autoInitSwiper({ page, marker, groupName, pane, controls, swiperOtions }: AutoSwiper): void {
  const PAGE_DOM = $(page);
  const SWIPER_GROUP = PAGE_DOM.find(marker);
  if (!PAGE_DOM.length || !SWIPER_GROUP.length) return;
  let temp: any = {};

  function setControl(control: any, select: string) {
    let temp: any = {};
    for (const key in control) {
      if (key == "pagination") {
        temp[key] = {
          el: select + " " + control[key],
          clickable: swiperOtions?.ClickAble ?? false,
        };
      } else if (key == "navigation") {
        temp[key] = {
          nextEl: select + " " + control[key] + "-next",
          prevEl: select + " " + control[key] + "-prev",
        };
      }
    }
    return temp;
  }
  SWIPER_GROUP.each(function (i, el) {
    // i = i + 1;
    const SWIPER_SELECT = page + " " + marker + "_" + i;
    const SWIPER_CLASS = (marker + "_" + i).replace(".", "");
    $($(el)).addClass(SWIPER_CLASS);
    const res = JSON.stringify(controls) !== "{}" ? setControl(controls ?? {}, SWIPER_SELECT) : {};
    temp[SWIPER_CLASS] = new Swiper(SWIPER_SELECT + " .swiper", {
      ...swiperOtions,
      ...res,
    });
    if (pane && pane != "") {
      // const EL = $(pane)[i] as any;
      const EL = $(temp[SWIPER_CLASS].el).parents(".tab-pane")[0] as any;
      EL.swiperList = EL.swiperList || [];
      EL.swiperList.push(temp[SWIPER_CLASS]);
    }
  });

  if (!window.swiperGroup || !groupName) return;
  window.swiperGroup[groupName] = {
    ...window.swiperGroup[groupName],
    ...temp,
  };
}

/**
 * 动态导入CSS或JavaScript文件的函数。
 *
 * 该函数根据传入的选项懒加载指定的CSS或JavaScript文件，并在所有文件加载完成后执行回调函数（如果有）。
 *
 * @function ImportBundle
 * @param {BundleImporter.BundleOptions} options - 导入选项对象。
 * @param {string} options.type - 必填字段，指定导入类型，可选值为 `"css"` 或 `"js"`。
 * @param {boolean} [options.isIndex=false] - 可选字段，指定是否同时在首页加载资源。
 * @param {boolean} [options.onlyIndex=false] - 可选字段，指定是否仅在首页加载资源。
 * @param {boolean} [options.isMobile=false] - 可选字段，指定是否仅在移动设备上加载资源，如果当前设备的宽度小于768px，将不加载资源。
 * @param {string} [options.position="start"] - 可选字段，指定加载标签的位置，`"end"`表示在`head`标签的末尾插入，默认为在开始插入。
 * @param {Function} [options.callback] - 可选字段，所有资源加载完成后的回调函数。
 *
 * @param {BundleImporter.ScriptSrc[] | string[]} src - 要加载的资源数组。对于`"css"`类型，传入字符串数组。对于`"js"`类型，传入包含资源信息的对象数组。
 *
 * @returns {Promise<boolean>} - 返回一个Promise对象，表示资源是否成功加载。
 */
export function ImportBundle(options: BundleImporter.BundleOptions, src: BundleImporter.ScriptSrc[] | string[]) {
  const PATH = window.location.pathname;
  const INDEX_FLAG = /index.html$/g.test(PATH) || PATH.includes("/index-");
  if (!options.isIndex && !options.onlyIndex && (PATH == "/" || INDEX_FLAG)) return;
  if (options.onlyIndex && PATH !== "/" && !INDEX_FLAG) return;
  if (options.isMobile && document.body.clientWidth < 768) return;

  let _count: number = src.length || 0;
  let _scritpLoaded: number = 0;
  let _resolve: (value: boolean) => void = () => {};
  const documentFragment: DocumentFragment = document.createDocumentFragment();

  // 生成css标签
  function createCssLink(linkSrc: string[]) {
    linkSrc.forEach((link) => {
      if (typeof link !== "string") return;
      const L = document.createElement("link");
      L.rel = "stylesheet";
      L.href = link;
      documentFragment.appendChild(L);
      _scritpLoaded++;
      checkAllScriptsLoaded();
    });
  }
  // 生成script标签
  function createScriptSrc(linkSrc: BundleImporter.ScriptSrc[]) {
    const onload = (item: BundleImporter.ScriptSrc) => {
      _scritpLoaded++;
      if (item.fn && typeof item.fn == "function") {
        item.fn();
      }
      checkAllScriptsLoaded();
    };

    linkSrc.forEach((item) => {
      if (!item || (!item.src && typeof item !== "object")) return;
      if (item.isMobile && document.body.clientWidth < 768) {
        _count--;
        return;
      }
      const script = document.createElement("script");
      script.src = item.src;
      script.defer = item?.defer ?? false;
      script.async = item?.async ?? false;
      script.onload = () => onload(item);
      documentFragment.appendChild(script);
    });
  }
  function checkAllScriptsLoaded() {
    if (_scritpLoaded === _count) {
      if (options.callback && typeof options.callback == "function") {
        options.callback();
      }
      _resolve(true);
    }
  }
  // 导入
  function Import() {
    return new Promise<boolean>((resolve, _reject) => {
      _resolve = resolve;
      const container = document.getElementsByTagName("head")[0];
      const Pos = container.querySelector('link[rel="stylesheet"]');
      if (options.type === "css") {
        createCssLink(src as string[]);
      } else {
        createScriptSrc(src as BundleImporter.ScriptSrc[]);
      }
      if (options.position && options.position === "end") {
        container.appendChild(documentFragment);
      } else {
        container.insertBefore(documentFragment, Pos);
      }
    });
  }
  return Import();
}

export class SwiperVideo {
  private _Swiper: Swiper | undefined = undefined;
  constructor(swiper: Swiper, opts?: any) {
    this._Swiper = swiper;
    if (!this._Swiper) throw Error("swiper can't not be empty.");
    this._addEventListener();
  }
  private _addEventListener() {
    this._Swiper!.on("init", (S) => {
      S.autoplay.stop();
      const videoList = $(S.slides).find("video");
      if (!videoList.length) return;
      videoList.on("ended", () => {
        S.slideNext();
        S.autoplay.start();
      });
    });
    this._Swiper!.on("slideChangeTransitionStart", (S) => {
      $(S.slides).each((_i, item) => {
        const V = this.getVideo(item);
        if (V) V[0].pause();
      });
      const currentSlide = S.slides[S.activeIndex];
      const video = this.getVideo(currentSlide);
      if (video) {
        S.autoplay.stop();
        video[0].play();
      } else {
        S.autoplay.start();
      }
    });
  }
  getVideo(target: HTMLElement | Element) {
    const res = $(target).find("video");
    if (res && res.length) {
      return res;
    } else {
      return false;
    }
  }
}

export function isMobile(w: number = 620): boolean {
  const windowWidth = $(window).width()!;
  return windowWidth <= w;
}

const preventDefault = (e: Event) => {
  e.preventDefault();
};
export function catchWheelEvent(enable: boolean) {
  if (enable) {
    $("html").css("overflow-y", "hidden");
    // document.addEventListener("wheel", preventDefault, { passive: false });
    // document.addEventListener("touchmove", preventDefault, { passive: false });
  } else {
    $("html").css("overflow-y", "initial");
    // document.removeEventListener("wheel", preventDefault);
    // document.removeEventListener("touchmove", preventDefault);
  }
}

/**
 * 将列表项按指定的断点分组的函数。
 *
 * 该函数从传入的jQuery对象中读取自定义CSS属性`--item`，根据该值将列表项分组，每组包含指定数量的列表项，通常配合GSAP制作实现 可视列表行 的动画。
 *
 * @function listToGroup
 * @param {JQuery<HTMLElement>} list - 需要分组的jQuery对象列表。
 *
 * @returns {JQuery<HTMLElement>[]} - 返回一个数组，每个元素都是一个包含指定数量列表项的jQuery对象组。
 */
export function listToGroup(list: JQuery<HTMLElement>) {
  const breakpoint = Number(list.css("--item"));
  const tempList: any[] = [];
  for (let i = 0; i < list.length; i += breakpoint) {
    const group = list.slice(i, i + breakpoint);
    tempList.push(group);
  }
  return tempList;
}

interface CreatedThumbsOpts {
  swiperOptions: SwiperOptions;
  cloneTarget?: string;
}

/**
 * 创建并初始化缩略图Swiper的函数。
 *
 * 该函数根据主Swiper实例中的幻灯片生成缩略图，并将缩略图与主Swiper进行联动。
 *
 * @function createdThumbs
 * @param {Swiper} swiper - 主Swiper实例，用于同步缩略图的主视图Swiper。
 * @param {string} thumbsSelect - 缩略图Swiper的容器选择器，用于定位缩略图的HTML元素。
 * @param {SwiperOptions} [opts] - 可选的Swiper配置对象，用于定制缩略图Swiper的行为和外观。
 *
 * @returns {void}
 */
export function createdThumbs(swiper: Swiper, thumbsSelect: string, opts?: CreatedThumbsOpts) {
  const slideList = $(swiper.el).find(".swiper-slide");
  const container = $(thumbsSelect); // 缩略图Swiper
  const wrapper = $("<div class='swiper-wrapper'></div>");
  if (!slideList.length || !container.length) return;
  const tempFragment = document.createDocumentFragment();
  slideList.each((_i, item) => {
    const target = $(item).find(opts?.cloneTarget || ".img-box");
    const clone = $(target).clone().removeClass("zoomSl")[0];
    const slide = $(`<div class='swiper-slide'></div>`);
    slide.append(clone);
    tempFragment.appendChild(slide[0]); // Append the slide to the fragment
  });

  wrapper.append(tempFragment);
  container.append(wrapper);
  const THUMBS = new Swiper(container[0], opts?.swiperOptions ?? {});
  swiper.thumbs.swiper = THUMBS;
  swiper.on("afterInit", (S) => {
    S.thumbs.init();
    S.thumbs.update(true);
    S.update();
  });
  swiper.on("slideChange", (S) => {
    const thumbs = S.thumbs.swiper;
    const currentIdx = thumbs.params.loop ? S.activeIndex : S.realIndex;
    thumbs.slideTo(currentIdx, 500, false);
  });
}
